import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Dash: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path fill="currentColor" d="M9.898 14.445V12.25h4.313v2.195H9.898Z" />
  </Icon>
);
